import ErrorIcon from "@mui/icons-material/CancelRounded";
import CheckIcon from "@mui/icons-material/CheckRounded";
import WarningIcon from "@mui/icons-material/WarningRounded";
import type { LogSeverity } from "../../../api/types/logTypes";

const LogStatusIcon = ({ severity }: { severity: LogSeverity }) => {
  switch (severity) {
    case "Information":
      return <CheckIcon color="primary" />;
    case "Warning":
      return <WarningIcon color="warning" />;
    case "Error":
      return <ErrorIcon color="error" />;
    default:
      return null;
  }
};

export default LogStatusIcon;
